import React, { useState, useEffect, Fragment } from "react";
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import ViewTabs from "./ViewTabs";

const ViewNewEdit = (props: any) => {
  console.log("Panel artefacto", props);
  const [value, setValue] = useState(0);
  const [alignment, setAlignment] = useState("diario");
  const [openModal, setOpenModal] = React.useState(false);

  useEffect(() => {
    const objDataInstance = props.data;
    if (props.data) {
      const firstInstanceId = objDataInstance.instance_id;
      setValue(0); // Asegurarte de que el primer Tab esté seleccionado
      setAlignment("diario"); // Configura el periodo por defecto
    }
  }, []);

  const handleAlignmentChange = (newAlignment: string) => {
    console.log("newAlignment........", newAlignment);
    setAlignment(newAlignment);
  };

  return (
    <ViewTabs
      dataUsuarios={props.dataUsuarios}
      onAlignmentChange={handleAlignmentChange}
      instanceId={props.data.instance_id}
    />
  );
};

export default ViewNewEdit;
